import { ChangeDetectorRef, Directive, OnDestroy, ViewChild, ViewRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { App } from '@df/core/app';
import { Subscription } from 'rxjs';
import { FormWizardStepComponent } from './form-wizard-step.component';
@Directive()
export abstract class FormWizardStepAbstract implements OnDestroy {
    /**
     * Step form  (check also ngOnDestroy)
     * important: you need to put #stepForm="ngForm" on form element in template
     */
    protected _stepForm?: NgForm;
    @ViewChild('stepForm', { static: false })
    set stepForm(form: NgForm) {
        this.onStepFormSet(form);
    }
    protected subscription = new Subscription();
    constructor(readonly app: App, protected changeDetectorRef: ChangeDetectorRef, readonly formWizardStepComponent: FormWizardStepComponent) { }
    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
    protected onStepFormSet(form: NgForm): void {
        this.formWizardStepComponent.removeForm(this._stepForm);
        this.formWizardStepComponent.addForm(form);
        this._stepForm = form;
        this.subscription?.unsubscribe();
        this.subscription.add(this.formWizardStepComponent.submittedChange.subscribe(() => this.detectChanges()));
        this.subscription.add(this._stepForm?.control?.valueChanges?.subscribe(() => this.detectChanges()));
        this.subscription.add(this._stepForm?.ngSubmit?.subscribe(() => this.detectChanges()));
    }
    protected detectChanges() {
        if (!(<ViewRef>this.changeDetectorRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }
}
